"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const react_2 = require("react");
const fa_1 = require("react-icons/fa");
const signalsKinds_1 = require("../../../../data/constants/signalsKinds");
const Select_1 = __importDefault(require("../../../elements/Select"));
const useEditRangeModal_1 = __importDefault(require("../hooks/useEditRangeModal"));
const styles = (0, react_1.css) `
  width: 66px;
  padding: 0 !important;

  button {
    background-color: transparent;
    border: none;
    padding: 5px;
  }

  button:disabled {
    opacity: 0.6;
  }
`;
const selectBoxStyle = {
    marginLeft: 2,
    marginRight: 2,
    border: 'none',
    height: '20px',
};
function ActionsColumn({ row, onHoverSignal, rowSpanTags, showKind, showDeleteAction, showEditAction, showZoomAction, }) {
    const { editRange, deleteRange, changeRangeSignalKind, zoomRange } = (0, useEditRangeModal_1.default)(row);
    const showActions = showDeleteAction || showEditAction || showZoomAction;
    return ((0, jsx_runtime_1.jsxs)(react_2.Fragment, { children: [showKind && ((0, jsx_runtime_1.jsx)("td", { ...onHoverSignal, children: (0, jsx_runtime_1.jsx)(Select_1.default, { onChange: changeRangeSignalKind, items: signalsKinds_1.SIGNAL_KINDS, defaultValue: row.tableMetaInfo.signal.kind, style: selectBoxStyle }) })), showActions && ((0, jsx_runtime_1.jsxs)("td", { ...rowSpanTags, css: styles, children: [showDeleteAction && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "delete-button", onClick: () => deleteRange(), children: (0, jsx_runtime_1.jsx)(fa_1.FaRegTrashAlt, {}) })), showZoomAction && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "zoom-button", onClick: () => zoomRange(), children: (0, jsx_runtime_1.jsx)(fa_1.FaSearchPlus, { title: "Zoom to range in spectrum" }) })), showEditAction && ((0, jsx_runtime_1.jsx)("button", { type: "button", className: "edit-button", onClick: () => editRange(), children: (0, jsx_runtime_1.jsx)(fa_1.FaEdit, { color: "blue" }) }))] }))] }));
}
exports.default = ActionsColumn;
